import request from '@/utils/request';
export const getDimensionList = (params: any) =>
  request({
    url: 'EvaluateDimension/dimensionList',
    method: 'get',
    params
  });
  export const delEvaluateDimension = (data: any) =>
  request({
    url: 'EvaluateDimension/dimension',
    method: 'delete',
    data
  });
  export const addEvaluateDimension = (data: any) =>
  request({
    url: 'EvaluateDimension/dimension',
    method: 'post',
    data
  });
  export const modifyEvaluateDimension = (data: any) =>
  request({
    url: 'EvaluateDimension/dimension',
    method: 'put',
    data
  });
  export const sendDimensionRelease = (data: any) =>
  request({
    url: 'EvaluateDimension/dimensionRelease',
    method: 'post',
    data
  });